var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.42841 12.7377C1.42841 13.6068 2.11412 14.3179 2.95222 14.3179H9.04746C9.88555 14.3179 10.5713 13.6068 10.5713 12.7377V3.2562H1.42841V12.7377ZM3.30269 7.112L4.37698 5.99793L5.99984 7.67299L7.61507 5.99793L8.68936 7.112L7.07412 8.78706L8.68936 10.4621L7.61507 11.5762L5.99984 9.90113L4.3846 11.5762L3.31031 10.4621L4.92555 8.78706L3.30269 7.112ZM8.6665 0.885826L7.9046 0.0957031H4.09508L3.33317 0.885826H0.666504V2.46607H11.3332V0.885826H8.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.108e8aa9af3d7163fd9512eda76aab2a.svg";
export { ForwardRef as ReactComponent };